module.exports = __webpack_public_path__ + "static/media/r321.3df79d35.jpg";